import React from 'react';
import PropTypes from 'prop-types';
import RevealSelection from '../RevealSelection';
import { RunnerCard } from '../RunnerCard';
import * as Styled from './styles';

export const AnimationModal = ({
    title,
    horseName,
    clothNumber,
    jockeyName,
    trainerName,
    silk
}) => {
    return (
        <Styled.Modal>
            <Styled.ModalContent>
                <Styled.Heading>
                    And your {title} Sweepstake horse is&hellip;
                </Styled.Heading>
                <RevealSelection>
                    <RunnerCard
                        clothNumber={clothNumber}
                        horseName={horseName}
                        jockeyName={jockeyName}
                        trainerName={trainerName}
                        silk={silk}
                    />
                </RevealSelection>
            </Styled.ModalContent>
        </Styled.Modal>
    );
};

AnimationModal.defaultProps = {
    clothNumber: null,
    jockeyName: null,
    trainerName: null,
    silk: null
};

AnimationModal.propTypes = {
    title: PropTypes.string.isRequired,
    horseName: PropTypes.string.isRequired,
    clothNumber: PropTypes.string,
    jockeyName: PropTypes.string,
    trainerName: PropTypes.string,
    silk: PropTypes.string
};

export default AnimationModal;
